<template>
  <ViewCustomRow @addNewRow="addNewRow" @hide="onHideDialog" v-model:showRowDialog="showDialog" :rowId="rowId"
    :masterDetail="masterDetail" :dialogOptions="dialogOptions" :permissions="permissions" :entityKey="entityKey"
    entityName="request_user" entitySpec="row" ref="RequestUserRow" :requiredFields="{
      module_id: true,
      request_type_id: true,
      request_user_name: true,
      priority_id: true,
      user_phone: true,
    }" :style="{ width: '60%' }">
    <template #header="{ rowData }">
      {{ rowId === -1 ? 'Новая заявка' : rowData.request_user_name }}
    </template>
    <template #header-right="{ rowData }">
      <div style="display: flex">
        <div style="display: inline-block">
          <Button v-if="rowData?.request_state_id === 8 && rowId > 0" label="Отправить" class="p-button-succes"
            icon="pi pi-check" @click="onSucces" />
        </div>
      </div>
    </template>
    <template #body="{ rowData, submitted }">
      <span v-show="!rowData.request_state_id || rowData?.request_state_id === 8" style="color: red">
        Важно!
        <br>После создания заявка сохраняется со статусом «На согласовании». Это ещё не значит, что она отправлена в
        техподдержку.
        <br>Чтобы отправить заявку в техподдержку:
        <br>Сохраните её.
        <br>Откройте заявку заново.
        <br>Прикрепите нужные файлы(если требуется).
        <br>Нажмите кнопку «Отправить»..
      </span>
      <div class="formgrid grid align-items-center vertical-container mt-1">
        <div class="col-12">
          <div class="formgrid grid align-items-center vertical-container">
            <div class="col-2">
              <label for="user_sname">Заявитель:</label>
            </div>
            <div class="col-2">
              <InputText id="user_sname" autofocus v-model="rowData.user_sname" disabled />
            </div>
            <div class="col-2">
              <label for="company_name" class="mb-1">Подразделение: </label>
            </div>
            <div class="col-2">
              <InputText id="company_name" autofocus v-model="rowData.company_name" disabled />
            </div>
            <div class="col-2">
              <label for="create_date">Дата заявки:</label>
            </div>
            <div class="col-2">
              <CustomCalendar id="create_date" dateFormat="dd.mm.yy" hideOnDateTimeSelect showTime
                :value="rowData.create_date" disabled />
            </div>
          </div>
          <div class="formgrid grid align-items-center vertical-container mt-2">
            <div class="col-2">
              <label for="request_state_id">Статус:</label>
            </div>
            <div class="col-2">
              <Dropdown id="request_state_id" v-model="rowData.request_state_id" :options="dialogOptions.request_state"
                optionLabel="request_state_name" optionValue="request_state_id" appendTo="body" disabled />
            </div>
            <div class="col-2">
              <label for="module_id">Модуль:</label>
            </div>
            <div class="col-2">
              <Dropdown id="module_id" v-model="rowData.module_id" optionLabel="module_name" filter
                :disabled="rowData.request_state_id !== 8" :options="modules" optionValue="module_id" appendTo="body"
                :class="{
                  'p-invalid':
                    submitted ? (rowData.module_id || '') == '' : false,
                }" />
            </div>
            <div class="col-2">
              <label for="request_type_id">Тип:</label>
            </div>
            <div class="col-2">
              <Dropdown id="request_type_id" v-model="rowData.request_type_id" :options="dialogOptions.request_type"
                filter :disabled="rowData.request_state_id !== 8" optionLabel="request_type_name"
                optionValue="request_type_id" appendTo="body" :class="{
                  'p-invalid':
                    submitted ? (rowData.request_type_id || '') == '' : false,
                }" />
            </div>
          </div>
          <div class="grid align-items-center vertical-container mt-2">
            <div class="col-2">
              <label for="request_user_name">Наименование:</label>
            </div>
            <div class="col-6">
              <InputText id="request_user_name" autofocus v-model="rowData.request_user_name"
                :disabled="rowData.request_state_id !== 8" :class="{
                  'p-invalid':
                    submitted ? (rowData.request_user_name || '') == '' : false,
                }" />
            </div>
            <div class="col-2">
              <label for="priority_id">Приоритет:</label>
            </div>
            <div class="col-2">
              <Dropdown id="priority_id" v-model="rowData.priority_id" :options="dialogOptions.priority"
                :disabled="rowData.request_state_id !== 8" optionLabel="priority_name" optionValue="priority_id"
                appendTo="body" :class="{
                  'p-invalid':
                    submitted ? (rowData.priority_id || '') == '' : false,
                }" />
            </div>
          </div>
          <div class="grid align-items-center vertical-container mt-2">
            <div class="col-2">
              <label for="request_user_desc">Подробности:</label>
            </div>
            <div class="col-6">
              <Textarea id="request_user_desc" v-model="rowData.request_user_desc"
                :disabled="rowData.request_state_id !== 8" />
            </div>
            <div class="col-2">
              <label for="user_phone">Тел. для связи:</label>
            </div>
            <div class="col-2">
              <InputText id="user_phone" autofocus v-model="rowData.user_phone"
                :disabled="rowData.request_state_id !== 8" :class="{
                  'p-invalid':
                    submitted ? (rowData.user_phone || '') == '' : false,
                }" />
            </div>
          </div>
          <div class="grid align-items-center vertical-container mt-1">
            <div class="col-2">
              <label for="developer_sname">Исполнитель:</label>
            </div>
            <div class="col-4">
              <InputText id="developer_sname" autofocus v-model="rowData.developer_sname" disabled />
            </div>
            <div class="col-2">
              <label for="developer_phone">Контакт исполнителя:</label>
            </div>
            <div class="col-4">
              <InputText id="user_phone" autofocus v-model="rowData.developer_phone" disabled />
            </div>
          </div>
          <div class="grid align-items-center vertical-container mt-2" v-if="rowData.request_denied">
            <div class="col-2">
              <label for="request_denied">Причина отказа:</label>
            </div>
            <div class="col-10">
              <Textarea id="request_denied" v-model="rowData.request_denied" disabled />
            </div>
          </div>
        </div>
      </div>
      <TabView class="mt-1">
        <TabPanel header="Файлы">
          <ViewCustomData entityName="request_user_file" entitySpec="data" serviceName="FileService"
            :columns="FILE_COLUMNS" :masterDetail="{ request_user_id: rowId }" ref="viewRequestUserFile"
            :paginator="false" @selectedRow="onSelectedFile" @delete="onDeleteFile" :visibleButtons="{
              insert: false,
              edit: false,
            }">
            <template #toolbar>
              <div class="component-filter gap-1">
                <Button title="Скачать" icon="pi pi-download" class="mr-1 ml-1" @click="downloadFile"
                  :disabled="!selectionFile || !Object.keys(selectionFile).length" />
                <Button title="Загрузить" icon="pi pi-upload" :disabled="!(rowId > 0) || rowData.request_state_id !== 8"
                  @click="fileUploadDialog = true" />
              </div>
            </template>
          </ViewCustomData>
        </TabPanel>
        <TabPanel header="Отчет исполнителя" v-if="rowData.request_developer_report">
          <Textarea autofocus v-model="rowData.request_developer_report" disabled rows="3" />
        </TabPanel>
      </TabView>
    </template>
  </ViewCustomRow>
  <Dialog v-model:visible="fileUploadDialog" :style="{ width: '450px' }" header="Загрузка файла" :modal="true">
    <FileUpload @uploader="uploadFile" :customUpload="true" :multiple="false" :maxFileSize="1000000" ref="fileUploadRef"
      :fileLimit="1">
      <template #empty>
        <p>Перетащите файл для загрузки сюда</p>
      </template>
    </FileUpload>
  </Dialog>
</template>

<script>
import { ref, computed, getCurrentInstance, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'primevue/usetoast';
import { ViewCustomRow } from 'cdisoft-library';
import { FILE_COLUMNS } from './requestUserConstants.js';

export default {
  name: 'RequestUserDialog',
  mixins: [ViewCustomRow],
  setup() {
    const store = useStore();
    const toast = useToast();
    const instance = getCurrentInstance();

    const selectionFile = ref(null);
    const fileUploadDialog = ref(false);
    const RequestUserRow = ref(null);
    const viewRequestUserFile = ref(null);
    const fileUploadRef = ref(null);

    const user = computed(() => store.getters.user);
    const modules = computed(() => store.getters.modules);

    const prepareInsert = (rowData) => {
      const data = {
        request_user_id: null,
        request_type_id: rowData.request_type_id,
        request_state_id: rowData.request_state_id,
        priority_id: rowData.priority_id,
        module_id: rowData.module_id,
        request_user_name: rowData.request_user_name,
        request_user_desc: rowData.request_user_desc || null,
        create_date: store.getters.formatSqlDateTime(rowData.create_date, true),
        user_phone: rowData.user_phone,
      };
      return data;
    }

    const prepareUpdate = (rowData, masterDetail) => {
      const data = prepareInsert(rowData, masterDetail);
      delete data.create_date;
      return data;
    }

    const onDeleteFile = () => {
      selectionFile.value = null;
    }

    const prepareData = (rowData) => {
      let date = new Date(rowData.create_date);
      date = new Date(date.setHours(date.getHours() + new Date().getTimezoneOffset() / 60));
      rowData.create_date = date;
      selectionFile.value = null;
      return rowData;
    }

    const beforeOpenNewRow = (rowData) => {
      rowData.user_sname = user.value.user_shortname;
      rowData.create_date = new Date();
      rowData.priority_id = 3;
      rowData.request_state_id = 8;
      selectionFile.value = null;
    }

    const onSelectedFile = (value) => {
      selectionFile.value = value;
    }

    const downloadFile = () => {
      if (!selectionFile.value) return;
      const file = selectionFile.value;
      const decodedData = atob(file.file_data);
      const uInt8Array = new Uint8Array(decodedData.length);
      for (let i = 0; i < decodedData.length; ++i) {
        uInt8Array[i] = decodedData.charCodeAt(i);
      }
      const url = window.URL.createObjectURL(new Blob([uInt8Array]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', file.file_name);
      document.body.appendChild(link);
      link.click();
    }

    const onSucces = () => {
      const row = RequestUserRow.value;
      if (row) {
        row.submitted = true;
        if (row.validateDialog()) {
          row.rowData.request_state_id = 7; // новая
          row.saveRow();
        }
      }
    }

    const uploadFile = (fileList) => {
      fileUploadDialog.value = false;
      const file = fileList.files[0];
      viewRequestUserFile.value.FileService
        .uploadFile(file, {
          request_user_id: RequestUserRow.value?.rowId,
          file_name: file.name,
        })
        .then(() => {
          toast.add({
            severity: 'info',
            summary: 'Файл загружен',
            detail: 'Вложение успешно добавлено к заявке',
            life: 3000,
          });
          viewRequestUserFile.value.updateData();
        })
        .catch((er) => {
          store.commit('SET_ERROR', {
            er: er.response || er,
            source: ['RequestUserDialog', 'uploadFile'],
          });
        });
    }

    return {
      selectionFile,
      fileUploadDialog,
      RequestUserRow,
      viewRequestUserFile,
      fileUploadRef,
      modules,
      FILE_COLUMNS,

      prepareInsert,
      prepareUpdate,
      onDeleteFile,
      prepareData,
      beforeOpenNewRow,
      onSelectedFile,
      downloadFile,
      onSucces,
      uploadFile,
    };
  },
};
</script>
